import React, { useEffect } from "react";

export default function useOutsideClick($showing:boolean, $callback:()=>void, $ref?:React.RefObject<HTMLDivElement>){

    let isListening:boolean=false;

    let addedTime = 0;

    const _onDocClick=($event:MouseEvent)=>{
        
        let diff:number = Date.now()-addedTime;
        //we need to only allow differences greater than 10ms
        //adding a document click listener in the same stack of clicking a button will trigger the doc click right away 
        //so we need to ignore the 0-10 range (even though it'll most likely be 0 when it occurs)
        if($ref && $ref.current && diff>10){            
            let target:any = $event.target;
            let shouldClose:boolean=true;
            if($ref.current.contains(target)) shouldClose=false;            
            if(shouldClose){
                $callback();
            }
        }
    }    
    const _removeListener=()=>{
        if(isListening){
            isListening=false;
            document.removeEventListener("click", _onDocClick);
        }
    }
    const _addListener=()=>{
        if(!isListening){
            isListening=true;
            addedTime = Date.now();
            document.addEventListener("click", _onDocClick);
        }
    }

    useEffect(()=>{  
        if($showing){
            _addListener();
        }
        return _removeListener;
    },[$showing]);
}